<template>
    <v-navigation-drawer
        :value="drawerRightVisible"
        right
        app
        clipped
        fixed
        width="330"
    >
    <v-toolbar dense>
        <v-btn flat icon color="primary" @click.stop="$emit('toggleDrawer')">
            <v-icon>close</v-icon>
        </v-btn>
        
      <v-toolbar-title class="mr-5 align-center">
        <span class="title" >Filter</span>
      </v-toolbar-title>
        
    </v-toolbar>

    <slot name="content"></slot>

    </v-navigation-drawer>
</template>    

<script>
export default {
  props: {
    drawerRightVisible: {
      type: Boolean,
      default: false
    }
  }
};
</script>
